import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators , AbstractControl} from '@angular/forms';
import { FreeTrialService } from '../free-trial.service';
import { CacheCountryService } from 'src/app/services/cacheCountries.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import {ConfirmationService} from 'primeng/api';
import { Store } from '@ngrx/store';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import { ConfirmationModalComponent } from 'src/app/modules/shared/modal/confirmation-modal/confirmation-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { UserRoleService } from 'src/app/services/user-role.service';
import { CompanyService } from 'src/app/services/company.service';

@Component({
  selector: 'app-select-roles',
  templateUrl: './select-roles.component.html',
  styleUrls: ['./select-roles.component.scss']
})
export class SelectRolesComponent implements OnInit {

  @Output() notify: EventEmitter<number> = new EventEmitter<number>();
  @Input() companyId;
  listCountry: [];
  newPwdValidity:boolean;
  observableSubscription$ = new Subject();
  dirtyFlag: boolean = false;

  public creatingUserForm: FormGroup;
  public userDetails:any= [];
  rollTypeList :[];
  formChangesSubscription: any;
  // table columns
  gridCols = [
    { field: 'permissions', header: 'Permission'},
    { field: 'permissions', header: 'HR Manager'},
    { field: 'permissions', header: 'Immigration Manager'},
    { field: 'permissions', header: 'Immigration Specialities'},
    { field: 'permissions', header: 'Case Worker'}
];

  listRoles: object[] = [];
  listRole: any[];
  listPermissions: object[];
  roleDataSource = [];
  uniqueListRoles = [];
  origColumns = [];
  displayedColumns: string[] = [];
  disableFields = false;

  constructor(private formBuilder: FormBuilder, 
    protected store: Store<any>,
    public dialog: MatDialog,
    private companyService: CompanyService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private confirmationService: ConfirmationService,
    private cacheCountryService: CacheCountryService,
    private clientsService:FreeTrialService,
    private userRoleService: UserRoleService) {
      this.activatedRoute.params
      .subscribe(parameter => {
        let parameterId = null;
        if (parameter.hasOwnProperty('id')) {
          this.companyId = parameterId;
          this.companyService.getCompaniesById(parameter.id).subscribe(data => {
            if(data.status.code == 'ACTV')
              this.disableFields = true;
          });
        } else {

        }
      });
     }

  ngOnInit(): void {
    // this.companyId = 425;
    this.creatingUserFormInitialize();
    this.cacheCountryService.getCachedCountryList().subscribe(data => {
      if (data.listCountries.length > 0) {
        this.listCountry = data.listCountries.map(x => {
          return {
            ...x,
            countryPhoneCode: `${x.countryCode} - ${x.phoneCode}`
          };
        });
      }
    });

    // this.userRoleService.getRoleByCompanyId(parseInt(sessionStorage.getItem('companyId'))).subscribe(data => {
    //   if (data) {
        // this.userRoleService.getPermissions().subscribe(data => {
        //   this.listPermissions = data;
        //   //this.getReviewSummaryDetails();
        // });        
    //   }
    // });

    this.getUserRoles();
    this.getUserDetails();
  }
 
  ngAfterViewInit() {
    this.formChangesSubscription = this.creatingUserForm.statusChanges.subscribe(() => {
      if (this.creatingUserForm.dirty) {
        this.store.dispatch(new MarkDirtyFormAction({
          dirty: true
        }));
        this.dirtyFlag = true;
      }
      else {
        this.store.dispatch(new MarkCleanFormAction({
          dirty: false
        }));
        this.dirtyFlag = false;
      }
    });
  }

  getUserRoles(){
    this.creatingUserForm.reset();
    this.listRoles = [];
    // this.clientsService.getUserRoles().subscribe(data => {
    //   if(data){
    //     let selArray = [];
    //     data.forEach((role) => {
    //           if (role['name'] === 'Petitioner Admin') {
    //             role['inactive']=true;
    //             selArray.push(role['roleId']);
    //           }
    //           else{
    //             role['inactive']=false;
    //           }
    //           this.listRoles.push(role);
    //     });
    //     // this.clientsService.getUserRolesByCompany(this.companyId).subscribe(data => {
    //     //   if(data){
    //     //     // let selArray = [];
    //     //     this.listRoles.forEach((role) => {
    //     //       data.forEach((roleselected) => {
    //     //         if (role['name'] === 'Petitioner Admin') {
    //     //           // role['inactive']=true;
    //     //           // selArray.push(role['roleId']);
    //     //         }
    //     //         else
    //     //         {
    //     //           if (role['name'] === roleselected['name']) {            
    //     //           selArray.push(role['roleId']);
    //     //           } 
    //     //         }         
    //     //       });
    //     //     });
    //     //     this.creatingUserForm.patchValue({
    //     //       rollType: selArray
    //     //     });
    //     //     this.selectedRoles();
    //     //   }else
    //     //   {
    //     //     this.creatingUserForm.patchValue({
    //     //       rollType: selArray
    //     //     });
    //     //     this.selectedRoles();
    //     //   }
    //     // });
    //     // this.creatingUserForm.patchValue({
    //     //   rollType: selArray
    //     // });
    //     // this.selectedRoles();
    //   }
    // });
  }

  selectedRoles(){
    this.uniqueListRoles = [];
    this.origColumns = [];
    let selectedRoles = this.creatingUserForm.controls['rollType'].value;
    this.listRoles.forEach((uniqueRoles) => {
          if (!this.uniqueListRoles.find(x => x.name === uniqueRoles['name'])) {
            selectedRoles.forEach((selectedrole) => {
              if (selectedrole === uniqueRoles['roleId']) {              
                this.uniqueListRoles.push(uniqueRoles);
              }
              console.log(uniqueRoles['roleId'])
            });                      
          }
     });

    this.uniqueListRoles.forEach((element: any) => {
        if (element.name !== "" && element.name !== null) {
          this.origColumns.push({
            columnDef: element.name,
            header: element.name.toUpperCase(),
            columnType: 'check',
            customClass: ''
          });
        }
    });
    this.displayedColumns = this.origColumns.map(c => c.columnDef);
    this.buildRoleList(this.listPermissions);     
  }

   buildRoleList(permissions){
    this.listPermissions.forEach((v, k) => {
      // permissions.forEach(element => {
          let rowObj = {
            perm_name: v['description']
          }
          this.listRoles.forEach((val, key) => {
            rowObj[val['name']] = false;
            if (val['permissions'].length > 0) {
              val['permissions'].forEach(item => {
                if (item.id == v['id']) {
                  rowObj[val['name']] = true;
                }
              })
            } else {
              rowObj[val['name']] = false;
            }
          });
          this.roleDataSource.push(rowObj);
      });      
    // });
    return(this.roleDataSource);
  }

  getUserDetails(){
    // this.clientsService.getUserDetails(this.companyId).subscribe(data => {
    //   if(data){
    //     this.userDetails = data;
    //   }
    // });
  }

  creatingUserFormInitialize(){
    this.creatingUserForm = this.formBuilder.group({
      rollType: ['',Validators.required],
    });    
  }
  
  creatingUserFormSub(){
    const payload = this.creatingUserForm.controls['rollType'].value;    
    this.clientsService.assignRoles(this.companyId, payload)
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((response: any) => {
        if (response.status == 200) {
          this.toastr.success(response.message, 'Success');
          this.dirtyFlag = false;
          // this.creatingUserForm.reset();
        }
      });
  }


      onPrevious(){
        if (this.dirtyFlag) {
    
          this.dialog.open(ConfirmationModalComponent, {
            width: '400px',
            data: {
              update: {
                title: 'Unsaved Changes!',
                message: 'Changes you made on this section is not saved yet. Do you wish to continue?'
              },
              // buttons: ['No, Stay on the Page', 'Yes, Leave the Page']
              buttons: ['No', 'Yes'],
              disableClose: true
            }
          }).afterClosed().subscribe(confirmed => {
            if (confirmed) {
              this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
              this.dirtyFlag = false;
              this.notify.emit(0);
            }
          });
    
        } else {
          this.notify.emit(0);
        }
      }

      onNext() {
        if (this.dirtyFlag) {    
          this.dialog.open(ConfirmationModalComponent, {
            width: '400px',
            data: {
              update: {
                title: 'Unsaved Changes!',
                message: 'Changes you made on this section is not saved yet. Do you wish to continue?'
              },
              // buttons: ['No, Stay on the Page', 'Yes, Leave the Page']
              buttons: ['No', 'Yes'],
              disableClose: true
            }
          }).afterClosed().subscribe(confirmed => {
            if (confirmed) {
              this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
              this.dirtyFlag = false;              
              this.notify.emit(2);
            }
          });
    
        } else {
          this.notify.emit(2);
        }
      }
    
      onCancel(){
        if (this.dirtyFlag) {
    
          this.dialog.open(ConfirmationModalComponent, {
            width: '400px',
            data: {
              update: {
                title: 'Unsaved Changes!',
                message: 'Changes you made on this section is not saved yet. Do you wish to continue?'
              },
              // buttons: ['No, Stay on the Page', 'Yes, Leave the Page']
              buttons: ['No', 'Yes'],
              disableClose: true
            }
          }).afterClosed().subscribe(confirmed => {
            if (confirmed) {
              this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
              this.dirtyFlag = false;
              this.router.navigate([`/attorney-landing/clients`]);
            }
          });
    
        } else {
          this.router.navigate([`/attorney-landing/clients`]);
        }
    
      }
  
}